<template>

    <div>
        <b-select :options="templateOptions" :value="value" text-field="title" value-field="id"
            :size="size" @change="$emit('input', $event)" />
    </div>

</template>

<script lang="ts">
import { Vue, Prop, Component } from "vue-property-decorator";
import axios from "axios";
import { UserTask } from "@/models/UserTask";
import { NotificationOptions } from "@/util/NotificationOptionsPresets";

let templatesFetchPromise: Promise<UserTask[]> | null = null;

@Component({
    name: "TaskTemplateField",
})
export default class TaskTemplateField extends Vue {

    @Prop({ default: null }) value!: number | null;
    @Prop({ default: undefined }) size!: string | undefined;

    protected templates: UserTask[] = [];

    mounted() {
        this.getTaskTemplates();
    }

    async getTaskTemplates() {
        try {
            if (!templatesFetchPromise) {
                templatesFetchPromise = axios.get<UserTask[]>("/task/templates")
                    .then(r => r.data)
                    .finally(() => {
                        templatesFetchPromise = null;
                    });
            }

            this.templates = await templatesFetchPromise;
        } catch (err) {
            console.error(err);
            this.$notification(NotificationOptions.error(err));
        }
    }

    get templateOptions() {
        return [
            { title: "", id: null },
            ...this.templates
        ]
    }

}

</script>